// A API recusa nota que nao seja inteiro de 1 a 5. O Rating do Material-UI devolve null
// quando o usuario clica de novo na mesma estrela, e o estado inicial e 0.
export const isValidRating = (value) =>
  Number.isInteger(value) && value >= 1 && value <= 5;
